console.log("UPS customizer laddad");

document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("upsOpenDesigner");
  const modal = document.getElementById("upsDesignerModal");
  const uploadInput = document.getElementById("upsLogoUpload");
  const closeBtns = document.querySelectorAll("[data-close-modal]");
  const saveBtn = document.getElementById("upsSaveDesign");
  const deleteBtn = document.getElementById("upsDeleteLogo");

  let canvas = null;
  let logoObject = null;
  let currentPlacement = "left-chest";

  function getCurrentProductImage() {
    const img =
      document.querySelector(".product-gallery img") ||
      document.querySelector(".media-gallery img") ||
      document.querySelector(".product__media img") ||
      document.querySelector("[data-media-id] img") ||
      document.querySelector('img[src*="/products/"]');

    if (img && img.src) return img.src;

    return window.UPS_CUSTOMIZER_PRODUCT?.productImage;
  }

  function initCanvas() {
    if (typeof fabric === "undefined") return;

    if (!canvas) {
      canvas = new fabric.Canvas("upsCanvas", {
  preserveObjectStacking: true,
  uniformScaling: true
});
    }

    canvas.clear();

    const imageUrl = getCurrentProductImage();

    fabric.Image.fromURL(imageUrl, (img) => {
      img.scaleToWidth(1200);

      img.set({
        left: -180,
        top: -25,
        selectable: false,
        evented: false
      });

      canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
    }, { crossOrigin: "anonymous" });
  }

  function openModal() {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");

    setTimeout(() => {
      initCanvas();
    }, 100);

    console.log("Designer öppnad");
  }

  function closeModal() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
  }

  btn?.addEventListener("click", openModal);
  closeBtns.forEach((el) => el.addEventListener("click", closeModal));

  uploadInput?.addEventListener("change", (e) => {
    if (!canvas) return;

    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (event) => {
      fabric.Image.fromURL(event.target.result, (img) => {
        if (logoObject) canvas.remove(logoObject);

       img.scaleToWidth(130);

img.set({
  left: 330,
  top: 260,
  cornerColor: "#183f34",
  borderColor: "#183f34",
  transparentCorners: false,
  cornerStyle: "circle",
  lockUniScaling: true,
  lockScalingFlip: true
});

img.setControlsVisibility({
  mt: false,
  mb: false,
  ml: false,
  mr: false,
  tl: true,
  tr: true,
  bl: true,
  br: true,
  mtr: true
});

        logoObject = img;
        canvas.add(img);
        canvas.setActiveObject(img);
        canvas.renderAll();
      });
    };

    reader.readAsDataURL(file);
  });

  function setPlacement(type) {
    currentPlacement = type;

    if (!logoObject || !canvas) return;

    if (type === "left-chest") logoObject.set({ left: 330, top: 260 });
    if (type === "center-chest") logoObject.set({ left: 430, top: 330 });
    if (type === "back") logoObject.set({ left: 430, top: 260 });

    canvas.renderAll();
  }

  document.querySelectorAll("[data-placement]").forEach((el) => {
    el.addEventListener("click", () => {
      setPlacement(el.dataset.placement);
    });
  });

  deleteBtn?.addEventListener("click", () => {
    if (!logoObject || !canvas) return;
    canvas.remove(logoObject);
    logoObject = null;
    canvas.renderAll();
  });

  saveBtn?.addEventListener("click", () => {
    if (!canvas) return;

    document.getElementById("upsDesignPreview").value =
      canvas.toDataURL("image/png");

    document.getElementById("upsDesignData").value =
      JSON.stringify(canvas.toJSON());

    document.getElementById("upsDesignPlacement").value = currentPlacement;

    closeModal();
    alert("Designen är sparad.");
  });
});